import TabItemAPI from './tab-item-api';

export default TabItemAPI;
